import { render } from "./CommonButtonPrimary.vue?vue&type=template&id=4abb0149&scoped=true"
import script from "./CommonButtonPrimary.vue?vue&type=script&lang=js"
export * from "./CommonButtonPrimary.vue?vue&type=script&lang=js"

import "./CommonButtonPrimary.vue?vue&type=style&index=0&id=4abb0149&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abb0149"]])

export default __exports__